import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';
import { getTicketById } from './getTicketById';

export const assignTicketToSelf = createAsyncThunk(
  'ticket/assignToSelf',
  async ({ ticketId, businessId, agentId }, { getState, dispatch, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;

      const response = await axios.patch(
        `${ROOT_URL}/ticket/${ticketId}/${businessId}/assign-to-self`,
        { assigneeId: agentId },
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      await dispatch(getTicketById(ticketId));
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false
};

const assignTicketToSelfSlice = createSlice({
  name: 'assignTicketToSelf',
  initialState,
  reducers: {
    resetAssignState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(assignTicketToSelf.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(assignTicketToSelf.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(assignTicketToSelf.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetAssignState } = assignTicketToSelfSlice.actions;
export default assignTicketToSelfSlice.reducer; 